var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(-2.5 -2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M17.319,5.806,14.194,2.681A.625.625,0,0,0,13.75,2.5h-10A1.25,1.25,0,0,0,2.5,3.75v12.5A1.25,1.25,0,0,0,3.75,17.5h12.5a1.25,1.25,0,0,0,1.25-1.25v-10A.625.625,0,0,0,17.319,5.806ZM7.5,3.75h5v2.5h-5Zm5,12.5h-5v-5h5Zm1.25,0v-5A1.25,1.25,0,0,0,12.5,10h-5a1.25,1.25,0,0,0-1.25,1.25v5H3.75V3.75h2.5v2.5A1.25,1.25,0,0,0,7.5,7.5h5a1.25,1.25,0,0,0,1.25-1.25V4.006l2.5,2.5V16.25Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.e5c682c75955ca6777c40ab9046b383e.svg";
export { ForwardRef as ReactComponent };